import React from 'react';
import styled from 'styled-components';
import Product from '../../../merchandiser/Product';

const Wrapper = styled.div`
  height: 100% !important;
  .product-wrapper {
    height: 100% !important;
  }
`;

function CustomHit({ hit }) {
  return (
    <Wrapper>
      <Product
        key={hit.objectID}
        isCollections={false}
        merchandiserId={hit.id}
        index={hit.objectID}
        id={hit.id}
        fabric={{
          name: hit.fabric,
          collaborator: hit.collaborator
            ? {
                name: hit.collaborator
              }
            : null
        }}
        name={hit.name}
        price={hit.price}
        image={hit.images[0]}
        slug={hit.slug}
      />
    </Wrapper>
  );
}

export default CustomHit;
